import React, { useMemo, useState } from 'react'

import { LntDivider } from '@app/components/base'
import { Show } from '@app/components/util'
import { mapRoleToPosition } from '@app/utils'
import { useToggle } from '@app/hooks'

import { UserInfo, DropdownMenu, CommentContent, EditComment } from './components'

import styles from './styles.module.scss'

import type { CommentsItemProps } from './types'
import type { LntDropdownMenuItem } from '@app/components/base/Dropdown/types'

export const CommentsItem: React.FC<CommentsItemProps> = props => {
  const { data, onDeleteComment, onPatchComment } = props

  const isEditToggle = useToggle(false)
  const [message, setMessage] = useState(data?.message ?? '')

  const id = String(data?.id)

  const commentAuthorName = useMemo<string>(() => {
    return data?.author?.name ? data.author.name : 'Система'
  }, [data])

  const handlePatchComment = (): void => {
    onPatchComment?.(id, message)

    isEditToggle.setUntoggled()
  }

  const handleChangeMessage = (message: string): void => {
    setMessage(message)
  }

  const commentsActionsMenu: LntDropdownMenuItem[] = [
    {
      key: 'edit',
      label: 'Редактировать',
      onClick: () => isEditToggle.setToggled()
    },
    {
      key: 'delete',
      label: 'Удалить',
      onClick: () => onDeleteComment?.(id)
    }
  ]

  return (
    <div className={ styles.commentsItem }>
      <div className={ styles.commentsItem__topRow }>
        <UserInfo
          name={ commentAuthorName }
          role={ mapRoleToPosition(data?.author?.role) }
          editorName={ data?.editor?.name }
        />
        <div className={ styles.commentsItem__dates }>{ data?.createdAt }</div>
        <DropdownMenu
          items={ commentsActionsMenu }
          isDisabled={ data?.isSystemComment }
        />
      </div>

      <Show condition={ !isEditToggle.value }>
        <CommentContent message={ data?.message } />
      </Show>

      <Show condition={ isEditToggle.value }>
        <EditComment
          message={ data?.message }
          onCancel={ isEditToggle.setUntoggled }
          onChangeMessage={ handleChangeMessage }
          onPatchComment={ handlePatchComment }
        />
      </Show>

      <LntDivider className={ styles.commentsItem__divider } />
    </div>
  )
}
